module.exports = __webpack_public_path__ + "static/media/install4.ebb25909.png";